// extracted by mini-css-extract-plugin
export default {"gridsContainer":"eFileErrors_gridsContainer__RRUaF"};